// Types
import { Matrix3D } from 'rematrix';
import { Point } from '../../../common/maths/geometry/pointTypes';
import { RectSize } from '../../../common/maths/geometry/rect/rectTypes';
import { convertMatrixToCssTransformString } from '../../utils/cssUtil';

/**
 * Renders a transformation matrix as a CSS matrix3d transform on the specified DOM node.
 */
// FIXME-TS - Move into the cssUtil, but make the cssUtil TypeScript
export const renderTransformationMatrixCSS = (domElement: HTMLElement | null, transformationMatrix: Matrix3D): void => {
    if (!domElement || !transformationMatrix) return;

    const matrixTransform = convertMatrixToCssTransformString(transformationMatrix);
    domElement.style.transform = matrixTransform ? matrixTransform : '';
};

/**
 * Performs the CSS & HTML style updates for each of the canvas DOM elements required to coordinate
 * updating the transformation and canvas scroll properties.
 */
export const renderScrollAndTransformation = (
    canvasViewportElement: HTMLElement | null,
    scrollAreaElement: HTMLElement | null,
    canvasDocumentElement: HTMLElement | null,
    scrollAreaSize: RectSize,
    canvasScroll: Point,
    transformationMatrix: Matrix3D,
    zoomingClass = 'zooming',
): number | undefined => {
    if (!canvasDocumentElement || !scrollAreaElement || !canvasViewportElement) {
        console.warn(
            'Attempting to render scroll and transformation without DOM element references',
            canvasDocumentElement,
            scrollAreaElement,
            canvasViewportElement,
        );
        return;
    }

    const rafId = requestAnimationFrame(() => {
        // Turn off the zoom transformation transition, to ensure there's no animation to the new transformation
        renderTransformationMatrixCSS(canvasDocumentElement, transformationMatrix);

        // Immediately change the scroll area dimensions
        scrollAreaElement.style.width = `${scrollAreaSize.width}px`;
        scrollAreaElement.style.height = `${scrollAreaSize.height}px`;

        // And update the scroll to ensure the same section of the viewport is shown
        canvasViewportElement.scrollLeft = canvasScroll.x;
        canvasViewportElement.scrollTop = canvasScroll.y;
    });

    // Then remove the zooming class to re-enable scrolling
    // NOTE: This needs to happen outside the RAF in order to avoid a bug in Safari where visual glitches
    //  occur at the end of zooms. I gather this helps to schedule an animation frame, but I'm not certain why.
    canvasViewportElement.classList.remove(zoomingClass);
    document.body.classList.remove(zoomingClass);

    return rafId;
};
